module.exports = __webpack_public_path__ + "media/images/icon_list/tag-217fa2d4eddf53af73cc6a2f25aa32a8.svg";